import * as api from "api"
import { createContext } from "react"

export const ServiceCentersContext = createContext<{
  city: string
  cities: string[]
  setCity: (value: string) => void
  inHesder: boolean
  setInHesder: (value: boolean) => void
  centers: api.ServiceCenter[]
  selectedCenter: api.ServiceCenter
  setSelectedCenter: (value: api.ServiceCenter) => void
}>(null)
